import { createSignal } from '@verclam/pulsar';

/** A single open draft at a time: `fieldKey` addresses it, `isDirty` says whether its value has
 * moved away from the one it was seeded with. */
export type EditingField = { readonly fieldKey: string; readonly isDirty: boolean } | null;

const editingFieldSignal = createSignal<EditingField>(null);

export const setEditingField = (value: EditingField): void => {
	editingFieldSignal.value = value;
};

/** Only writes when the signal still addresses this field — a stale editor whose gesture resolves
 * after the user already moved on must never overwrite the field that replaced it. */
export const setEditingFieldDirty = (fieldKey: string, isDirty: boolean): void => {
	const current = editingFieldSignal.value;

	if (current !== null && current.fieldKey === fieldKey) {
		editingFieldSignal.value = { fieldKey, isDirty };
	}
};

export default editingFieldSignal;
